import styled from "@emotion/styled";
export const StyledMobileCarouselTagsComponent = styled.div``;
